import Component from '../core/Component';
import GoogleMapsLoader from 'google-maps';
import debounce from 'lodash/debounce';
import { createMarker } from './Marker'
GoogleMapsLoader.KEY = 'AIzaSyDXJ0yfhh8_VAml8Ib22knJAG9mGAF8PEo';

export default class GoogleMap extends Component {

    constructor(element) {
        super(element);

        this.latlng = null;
        this.isReady = false;

        this.handleResize = debounce(this.center.bind(this), 200)
    }

    prepare() {
        this.coords =  {
            lat: this.element.dataset.lat,
            lng: this.element.dataset.lng
        }

        GoogleMapsLoader.load(this.render)

        window.addEventListener('resize', this.handleResize)
        window.addEventListener('orientationchange', this.handleResize)
    }

    destroy() {
        this.map = null
        window.removeEventListener('resize', this.handleResize)
        window.removeEventListener('orientationchange', this.handleResize)
    }

    render = (google) => {
        const latlng = new google.maps.LatLng(this.coords.lat, this.coords.lng);
        this.google = google;
        this.latlng = latlng;

        this.map = new google.maps.Map(this.element, {
            center: latlng,
            zoom: 10,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: false,
            scaleControl: false,
            fullscreenControl: false,
            streetViewControl: false,
            mapTypeControl: false,
            styles: [],
        });
        const Marker = createMarker(google);

        var marker = new Marker({
            position: latlng,
            map: this.map
        });

        setTimeout(() => {
            this.isReady = true;
            this.center();
        }, 0);
    }

    center() {
        if (this.isReady) {
            this.google.maps.event.trigger(this.map,'resize');
            this.map.setCenter(this.latlng);
        }
    }
}
